import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "aa96203e-fc43-438e-b7fb-ee648bf0dfae", content: "Dc(front) = 3.49 m<br>Dc(back) = 1.93 m", options: {} },
  { id: "b11a37b2-cab3-4164-8c32-0527ad17ba85", content: "Dc(front) = 4.39 m<br>Dc(back) = 1.39 m", options: {} },
  { id: "fcd1bf57-1465-4b15-8b0d-543a1227ff11", content: "Dc(front) = 4.91 m<br>Dc(back) = 1.99 m", options: {} },
  { id: "013beeeb-5f45-480f-84a8-7badceb7268f", content: "Dc(front) = 4.19 m<br>Dc(back) = 1.33 m", options: {} },
];

export const task: Task = {
  id: "a37dfef7-a630-4932-9379-918f2c6c884a",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["013beeeb-5f45-480f-84a8-7badceb7268f"],
};
